
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lang/[locale]/pricing",
      function () {
        return require("private-next-pages/lang/[locale]/pricing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lang/[locale]/pricing"])
      });
    }
  